import { backgroundDefaultColor } from "../palette";

export const MuiPaper = {
  MuiPaper: {
    root: {
      backgroundColor: backgroundDefaultColor,
    },
  },
};
